module.exports = __webpack_public_path__ + "img/edge_activites_peche.f6a9782b.svg";